// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollToTopButton_root__yxLgz","visible":"ScrollToTopButton_visible__LrRWZ"};